exports.list = {
    path: '/penjualan_distributor',
    name: 'penjualan_distributor', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/penjualan_distributor/List.vue"),
}
exports.show = {
  path: '/penjualan_distributor/show/:no_faktur',
  name: 'penjualan_distributor_show', 
      meta: {
          authRequired: true,
      },
  component: () => import("@/views/main/penjualan_distributor/Show.vue"),
}